import { createSelector } from 'redux-bundler';

export const selectTeamMemberOptions = createSelector(
  'selectTeamMemberIDsByCurrentOrganization',
  'selectTeamMembersById',
  'selectBoardsById',
  'selectQueryObject',
  (teamMemberIDs, teamMemberById, boardsById, queryObject) => {
    const boardMemberIds =
      boardsById[queryObject.boardId]?.teamMembers?.map(({ id }) => id) || [];

    const teamMemberOptions = [];
    for (let i = 0, len = teamMemberIDs.length; i < len; i += 1) {
      const tmId = teamMemberIDs[i];
      const { userId, disabled, firstName, lastName, role } =
        teamMemberById[tmId] || {};

      if (userId && firstName && lastName && !disabled) {
        teamMemberOptions.push({
          id: userId,
          label: `${firstName} ${lastName}`,
          role,
          value: tmId,
        });
      }
    }

    return teamMemberOptions.sort(
      (a, b) => boardMemberIds.indexOf(a.id) - boardMemberIds.indexOf(b.id),
    );
  },
);

export const selectTeamMemberOptionsWithoutChatbot = createSelector(
  'selectTeamMemberOptions',
  (options) => options.filter(({ role }) => role !== 'Chatbot'),
);

export const selectChatbotTeamMemberOptions = createSelector(
  'selectTeamMemberOptions',
  (options) => options.filter(({ role }) => role === 'Chatbot'),
);
